import { Claim, ClaimControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  claim: Claim;
  xTENANTID?: string;
}

export const useClaimScrubValidation = () =>
  useMutationWithLoading(async (params: Params) =>
    new ClaimControllerApi(getConfigObject()).scrubClaim(
      params.claim,
      params.xTENANTID
    )
  );